import { Box, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  // 56~68px 썸네일에는 "small". 배지가 이미지를 절반 넘게 덮지 않도록.
  size?: "small" | "medium";
  // 좌측 상단이 기본. 카드처럼 좌측 상단에 체크박스가 있는 곳은 우측 하단으로 피한다.
  placement?: "top-left" | "bottom-right";
}

/**
 * SKU 로 모인 AI 수집 이미지임을 알리는 배지.
 *
 * 상품 자체 이미지와 구분하려고 이미지 좌측 상단에 얹는다.
 * 부모에 position: relative 가 있어야 한다.
 */
export default function PathPickAiImageBadge({
  size = "medium",
  placement = "top-left",
}: Props) {
  const { t } = useI18nHelper();
  const isSmall = size === "small";
  const offset = isSmall ? "2px" : "4px";
  const placementStyle =
    placement === "bottom-right"
      ? { bottom: offset, right: offset }
      : { top: offset, left: offset };

  return (
    <Box
      position={"absolute"}
      {...placementStyle}
      padding={isSmall ? "0 3px" : "1px 6px"}
      borderRadius={isSmall ? "3px" : "4px"}
      background={"#1272EF"}
      pointerEvents={"none"}
      title={t("path_pick:search_products.size_stock_modal.image_ai_tooltip")}
    >
      <Text
        textStyle={"caption-bold"}
        fontSize={isSmall ? "9px" : undefined}
        lineHeight={isSmall ? "14px" : undefined}
        color={"#FFFFFF"}
      >
        AI
      </Text>
    </Box>
  );
}
